export default __webpack_public_path__ + "static/Autumn Illustration-b8abea738b5dd46ff9db278c2b29c398.png";